import { createRoot } from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<App />);
